// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import Charts from "../SummaryTab/Charts";
// import Filtering from "../RuleCatalogue/Filtering";
// import PivotTable from "../SummaryTab/PivotTable";
// import heartLoading from "../../assests/heartLoading.gif";

// const SummarySave = ({
//   dashboardId = null,
//   currentFilters = {},
//   onFiltersChange,
//   searchTerm = "",
//   onSearchChange,
// }) => {
//   const BASE_URL = process.env.REACT_APP_API_URL;
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [activePeriod, setActivePeriod] = useState("");
//   const initialLoaded = useRef(false);
//   const [pivotGrouping, setPivotGrouping] = useState({});

//   useEffect(() => {
//     if (Object.keys(pivotGrouping).length > 0) {
//       onFiltersChange({ pivot_grouping: pivotGrouping });
//     }
//   }, [pivotGrouping, onFiltersChange]);

//   // 👉 GET /dashboard-view/summary/{dashboardId}
//   useEffect(() => {
//     if (!dashboardId) return;

//     setLoading(true);

//     axios
//       .get(
//         `${BASE_URL}/dashboard-view/summary/${dashboardId}?page=${page}&page_size=${pageSize}`
//       )
//       .then((res) => {
//         setData(res.data);

//         if (res.data.filters) {
//           onFiltersChange(res.data.filters);
//         }
//         if (res.data.search_term) {
//           onSearchChange(res.data.search_term);
//         }

//         initialLoaded.current = true;
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching saved summary view:", err);
//         setLoading(false);
//       });
//   }, [dashboardId, page, pageSize, BASE_URL, onFiltersChange, onSearchChange]);

//   const handlePeriodChange = (period) => setActivePeriod(period);

//   const handlePageChange = (newPage) => setPage(newPage);

//   const handlePageSizeChange = (newPageSize) => {
//     setPageSize(newPageSize);
//     setPage(1);
//   };

//   if (!data)
//     return (
//       <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
//         <div className="flex flex-col items-center space-y-3">
//           <img src={heartLoading} alt="Loading..." className="h-30" />
//           <span className="text-gray-700 text-[20px]">
//             Hang tight! The saved dashboard is loading...
//           </span>
//         </div>
//       </div>
//     );

//   // ✅ For saved view, charts data comes directly from dqMetrics
//   const scoresForCharts = data?.dqMetrics;

//   return (
//     <div className="summary">
//       <Filtering
//         availableFilters={data.filters}
//         currentFilters={currentFilters}
//         onFiltersChange={onFiltersChange}
//         searchTerm={searchTerm}
//         onSearchChange={onSearchChange}
//         showPeriodToggle={false} // Saved view doesn't need toggle
//         activePeriod={activePeriod}
//         onPeriodChange={handlePeriodChange}
//         onResetPeriod={() => setActivePeriod("")}
//         disabled={true} 
        
//       />

//       {scoresForCharts && <Charts scores={scoresForCharts} period={""} />}

//       <PivotTable
//         tableData={data.tableData}
//         paginationData={data.pagination}
//         filterList={data.filters?.name}
//         apiLoading={loading}
//         onPageChange={handlePageChange}
//         onPageSizeChange={handlePageSizeChange}
//         onGroupingChange={setPivotGrouping}
//       />
//     </div>
//   );
// };

// export default SummarySave;
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Charts from "../SummaryTab/Charts";
import Filtering from "../RuleCatalogue/Filtering";
import PivotTable from "../SummaryTab/PivotTable";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";

const SavedSummary = ({
  dashboardId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activePeriod, setActivePeriod] = useState("");
  const initialLoaded = useRef(false);
  const [pivotGrouping, setPivotGrouping] = useState({});

  useEffect(() => {
    if (Object.keys(pivotGrouping).length > 0) {
      onFiltersChange({ pivot_grouping: pivotGrouping });
    }
  }, [pivotGrouping, onFiltersChange]);

  // ✅ GET /dashboard-view/summary/{dashboardId}
  useEffect(() => {
    if (!dashboardId) return;

    setLoading(true);

    axios
      .get(
        `${BASE_URL}/dashboard-view/summary/${dashboardId}?page=${page}&page_size=${pageSize}`
      )
      .then((res) => {
        setData(res.data);

        // only push filters/searchTerm to parent on first load
        if (!initialLoaded.current) {
          if (res.data.filters) {
            onFiltersChange(res.data.filters);
          }
          if (res.data.search_term) {
            onSearchChange(res.data.search_term);
          }
          initialLoaded.current = true;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching saved summary view:", err);
        setLoading(false);
      });
  }, [dashboardId, page, pageSize, BASE_URL]); // ⛔ removed function props

  const handlePeriodChange = (period) => setActivePeriod(period);
  const handlePageChange = (newPage) => setPage(newPage);
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(1);
  };

  if (!data)
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={preloader} alt="Loading..." width={200} />
          <span className="text-gray-700 text-[20px]">
            Hang tight! The saved dashboard is loading...
          </span>
        </div>
      </div>
    );

  const scoresForCharts = data?.dqMetrics;

  return (
    <div className="summary">
      <Filtering
        availableFilters={data.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        showPeriodToggle={false}
        activePeriod={activePeriod}
        onPeriodChange={handlePeriodChange}
        onResetPeriod={() => setActivePeriod("")}
        disabled={true} 
      />

      {scoresForCharts && <Charts scores={scoresForCharts} period={""} />}

      <PivotTable
        tableData={data.tableData}
        paginationData={data.pagination}
        filterList={data.filters?.name}
        apiLoading={loading}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onGroupingChange={setPivotGrouping}
                pivotGrouping={data?.pivot_grouping || {}}

      />
    </div>
  );
};

export default SavedSummary;
